import React, { PureComponent } from 'react';
import cn from 'classnames';
import ProgressOnTable from './ProgressOnTable';
import NumberUtils from '../../utils/NumberUtils';

import PropTypes from 'prop-types';

class SpendTableRowTemplate extends PureComponent {
  static propTypes = {
    rowData: PropTypes.object,
    metadata: PropTypes.object,
    customClick: PropTypes.func,
    content: PropTypes.object,
  };
  onClick = () => {
    this.props.customClick(this.props.rowData.name, this.props.rowData);
  };
  renderColumnData = () => {
    const {
      rowData: { last_month, current_month, archived, joint, name, message },
      metadata,
    } = this.props;

    switch (metadata.columnName) {
      case 'name':
        return (
          <div
            className={cn('spendings__tag_name', {
              'column-fade': archived || joint,
            })}
          >
            <a onClick={this.onClick}>
              <span>{name}</span>
            </a>
          </div>
        );
      case 'current_month':
        return NumberUtils.appendCurrency('{}', current_month);
      case 'progress':
        return archived || joint ? null : <ProgressOnTable {...this.props} />;
      case 'last_month':
        return NumberUtils.appendCurrency('{}', last_month);
      case 'message':
        return message;
      default:
        return null;
    }
  };

  render() {
    return <div className="enabled">{this.renderColumnData()}</div>;
  }
}

export default SpendTableRowTemplate;
